const state = {
    loading: false,
};

const mutations = {
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
    RESET_META_STATE(state) {
        state.loading = false;
    },
};

const getters = {
    get_loading(state) {
        return state.loading;
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
